<div class="cart-control-exceptions">
  <div class="exceptions-heading">
    <span class="title">Exceptions</span>
    <span class="subtitle">Override the settings above for specific products</span>
  </div>

  <div class="quick-add">
    <span class="quick-add-label">QUICK ADD</span>
    @for (chip of chips; track chip.source) {
      @if (isChipAdded(chip.source)) {
        <span class="chip added" aria-disabled="true">✓ {{ chip.label }} · added</span>
      } @else {
        <button type="button" class="chip" (click)="addException(chip.source)">+ {{ chip.label }}</button>
      }
    }
  </div>
  <p class="quick-add-caption">
    Rules run in order from top to bottom — the first matching rule is applied, and no further rules are checked.
  </p>

  @if (exceptions.controls.length) {
    <!-- PDQ-7681 — no per-exception delete control (per design). Delete = remove all rules (the block
         auto-removes once it has had a rule); new exceptions are added via QUICK ADD / + Add exception.
         Stacked blocks are spaced by the container's gap (no sibling margins). -->
    <div class="exception-list">
      @for (exception of exceptions.controls; track exception.controls.id.value; let i = $index) {
        <div class="exception-block">
          <pdq-rules-dynamic-form
            [formGroup]="exception"
            formArrayFieldName="conditions"
            [rules]="exceptionRules | addCurrencyOption: shopCurrencySymbol"
            [entities]="exceptionEntities"
            [shopCurrencySymbol]="shopCurrencySymbol"
            [showEmptyRowByDefault]="true"
            [versionWithOrOperator]="true"
            (onRemove)="onRuleRemoved($event, exception)"></pdq-rules-dynamic-form>

          <div
            class="customers-can"
            [class.disabled]="exception.controls.actions.disabled"
            [formGroup]="exception.controls.actions">
            <span class="customers-can-label">Customers can:</span>
            <div class="checkbox-row">
              <pdq-checkbox formControlName="changeVariant" label="Change Variant" labelSize="medium"></pdq-checkbox>
              <pdq-checkbox formControlName="editQuantity" label="Edit Quantity" labelSize="medium"></pdq-checkbox>
              <pdq-checkbox formControlName="removeItems" label="Remove Items" labelSize="medium"></pdq-checkbox>
              <pdq-checkbox
                formControlName="showSubscriptionSelector"
                label="Show Subscription Selector"
                labelSize="medium"></pdq-checkbox>
            </div>
            @if (exception.controls.actions.controls.showSubscriptionSelector.value) {
              <cart-control-subscription-selector
                [typeControl]="exception.controls.actions.controls.subscriptionSelector.controls.type"
                [upgradeButtonLabelControl]="
                  exception.controls.actions.controls.subscriptionSelector.controls.upgradeButtonLabel
                "
                [upgradeButtonAppearanceControl]="
                  exception.controls.actions.controls.subscriptionSelector.controls.upgradeButtonAppearance
                "
                [upgradeButtonTextColorControl]="
                  exception.controls.actions.controls.subscriptionSelector.controls.upgradeButtonTextColor
                "
                [upgradeButtonLabelInvalid]="
                  exception.controls.actions.errors?.upgradeButtonLabelRequired
                "></cart-control-subscription-selector>
            }
          </div>
        </div>
      }
    </div>
  }

  <button type="button" class="add-exception" (click)="addException()">+ Add exception</button>
</div>
